// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  storageURL: 'gs://pineapplecms-dev-258d0.firebasestorage.app/',
  production: false,
  defaultProjectForLocalhost: 'pineapplelab',
  API_URL: 'https://us-central1-pineapplecms-dev-258d0.cloudfunctions.net',
  publicAppUrl: 'https://pineapplecms-dev-258d0-dd90a.web.app',
  bulkSalaryUpdatePath: '/bulkSalaryUpdate',
  firebase: {
    apiKey: 'AIzaSyC8XepQ16eST07T7giLQiQ9KTt8SNfBBKI',
    authDomain: 'pineapplecms-dev-258d0.firebaseapp.com',
    // DEV project has no Realtime Database provisioned yet — see final report.
    databaseURL: '',
    projectId: 'pineapplecms-dev-258d0',
    storageBucket: 'pineapplecms-dev-258d0.firebasestorage.app',
    messagingSenderId: '40110077233',
    appId: '1:40110077233:web:5e4a47793c31d5919cec10',
    measurementId: 'G-7ZEFHB3D0E',
    bucket: 'pineapplecms-dev-258d0.firebasestorage.app',
  },
  allowUIThemeChange: true,
  allowExternalAuth: true,
  sentryDsn:
    'https://e9a800ed6c2add4ea0957e8b297e57aa@o462724.ingest.us.sentry.io/4511475135676416',
  sentryEnvironment: 'development',
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
